export default "6b612cbd83b5b7f0.svg"